import { Box, Container, Typography, Divider, Link, Paper, Stack, Chip } from '@mui/material';
import { PublicSiteChrome, publicPageSx } from '../site/PublicSiteChrome';
import Footer from '../Footer';

const TOKENS = {
  primary: '#1E40AF',
  secondary: '#3B82F6',
  accent: '#D97706',
  bgDark: '#0B132B',
  bgCard: 'rgba(15, 23, 42, 0.75)',
  border: 'rgba(219, 234, 254, 0.15)',
  textPrimary: '#F8FAFC',
  textSecondary: '#94A3B8',
  textHighlight: '#60A5FA',
};

const sectionTitleSx = {
  fontWeight: 700,
  fontSize: { xs: '1.25rem', sm: '1.5rem' },
  color: TOKENS.textPrimary,
  mt: 4,
  mb: 2,
};

const textSx = {
  color: TOKENS.textSecondary,
  fontSize: { xs: '0.92rem', sm: '1rem' },
  lineHeight: 1.7,
  mb: 2,
};

const PrivacyPolicy = () => {
  const lastUpdated = 'July 20, 2026';

  return (
    <Box sx={{ ...publicPageSx, bgcolor: TOKENS.bgDark, color: TOKENS.textPrimary }}>
      <PublicSiteChrome title="Privacy Policy" />

      <Container maxWidth="md" sx={{ py: { xs: 6, md: 10 } }}>
        <Paper
          sx={{
            p: { xs: 4, sm: 6 },
            bgcolor: TOKENS.bgCard,
            border: `1px solid ${TOKENS.border}`,
            borderRadius: 3,
          }}
        >
          <Stack spacing={2} sx={{ mb: 4 }}>
            <Chip
              label="DATA PRIVACY & PROTECTION"
              size="small"
              sx={{
                alignSelf: 'flex-start',
                bgcolor: 'rgba(217, 119, 6, 0.18)',
                color: TOKENS.accent,
                fontWeight: 800,
                fontSize: 10,
              }}
            />
            <Typography variant="h3" sx={{ fontWeight: 800, letterSpacing: '-0.03em' }}>
              Privacy Policy
            </Typography>
            <Typography sx={{ color: TOKENS.textSecondary, fontSize: '0.9rem' }}>
              Last Updated: {lastUpdated}
            </Typography>
          </Stack>

          <Divider sx={{ borderColor: TOKENS.border, mb: 4 }} />

          <Typography component="h2" sx={sectionTitleSx}>
            1. Introduction
          </Typography>
          <Typography sx={textSx}>
            GeoVera ("we," "us," or "our") respects your privacy and is committed to protecting your
            personal and spatial data. This Privacy Policy explains how we collect, use, and
            safeguard your information across geovera.in, WebGIS, and DIGIPIN services.
          </Typography>

          <Typography component="h2" sx={sectionTitleSx}>
            2. Data We Collect
          </Typography>
          <Typography sx={textSx}>
            - Account Information: Name and email address provided during Google OAuth
            authentication.
            <br />
            - Spatial Data: Vector boundaries, attribute tables, and map configurations uploaded to
            your workspace.
            <br />- API & Usage Logs: IP address, endpoint requests, and DIGIPIN API key activity
            logs.
          </Typography>

          <Typography component="h2" sx={sectionTitleSx}>
            3. How We Use Data
          </Typography>
          <Typography sx={textSx}>
            Data is used strictly to provide WebGIS services, authenticate API requests, generate
            spatial exports, and send critical system notifications. We never sell your personal or
            spatial data to third parties.
          </Typography>

          <Typography component="h2" sx={sectionTitleSx}>
            4. Security & Compliance
          </Typography>
          <Typography sx={textSx}>
            Spatial layers and user credentials are encrypted in transit (TLS 1.3) and at rest.
            GeoVera complies with India DPDP Act 2023 and global data protection standards.
          </Typography>

          <Typography component="h2" sx={sectionTitleSx}>
            5. Contact Us
          </Typography>
          <Typography sx={textSx}>
            For privacy inquiries or data deletion requests, contact{' '}
            <Link
              href="mailto:privacy@geovera.in"
              sx={{ color: TOKENS.textHighlight, fontWeight: 600 }}
            >
              privacy@geovera.in
            </Link>
            .
          </Typography>
        </Paper>
      </Container>

      <Footer />
    </Box>
  );
};

export default PrivacyPolicy;
